/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In order: minute (0–59), hour (0–23), day of month (1–31), month (1–12 or jan–dec), and day of week (0–6 or sun–sat, where 0 and 7 are both Sunday).`)
};

const es_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En orden: minuto (0–59), hora (0–23), día del mes (1–31), mes (1–12 o jan–dec), y día de la semana (0–6 o sun–sat, donde 0 y 7 son domingo).`)
};

const de_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Reihenfolge: Minute (0–59), Stunde (0–23), Tag des Monats (1–31), Monat (1–12 oder jan–dec) und Wochentag (0–6 oder sun–sat, wobei sowohl 0 als auch 7 Sonntag bedeuten).`)
};

const nl_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In volgorde: minuut (0–59), uur (0–23), dag van de maand (1–31), maand (1–12 of jan–dec) en dag van de week (0–6 of sun–sat, waarbij zowel 0 als 7 zondag zijn).`)
};

const fr_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans l'ordre : minute (0–59), heure (0–23), jour du mois (1–31), mois (1–12 ou jan–dec), et jour de la semaine (0–6 ou sun–sat, où 0 et 7 signifient tous deux dimanche).`)
};

const it_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In ordine: minuto (0–59), ora (0–23), giorno del mese (1–31), mese (1–12 o jan–dec), e giorno della settimana (0–6 o sun–sat, dove 0 e 7 sono entrambi domenica).`)
};

const pt_br2_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em ordem: minuto (0–59), hora (0–23), dia do mês (1–31), mês (1–12 ou jan–dec), e dia da semana (0–6 ou sun–sat, onde 0 e 7 são ambos domingo).`)
};

const pt_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em ordem: minuto (0–59), hora (0–23), dia do mês (1–31), mês (1–12 ou jan–dez), e dia da semana (0–6 ou dom–sáb, onde 0 e 7 são ambos domingo).`)
};

const ja_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`順序通り：分（0～59）、時間（0～23）、日（月内）（1～31）、月（1～12またはjan～dec）、曜日（0～6またはsun～satで、0と7は両方とも日曜日）。`)
};

const zh_cr_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依次为：分钟（0 到 59）、小时（0 到 23）、日期（1 到 31）、月份（1 到 12，或 jan 到 dec）、以及星期几（0 到 6，或 sun 到 sat，其中 0 和 7 都表示星期日）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq1_a", locale)
	if (locale === "en") return en_cr_faq1_a(inputs)
	if (locale === "es") return es_cr_faq1_a(inputs)
	if (locale === "de") return de_cr_faq1_a(inputs)
	if (locale === "nl") return nl_cr_faq1_a(inputs)
	if (locale === "fr") return fr_cr_faq1_a(inputs)
	if (locale === "it") return it_cr_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq1_a(inputs)
	if (locale === "pt") return pt_cr_faq1_a(inputs)
	if (locale === "ja") return ja_cr_faq1_a(inputs)
	return zh_cr_faq1_a(inputs)
};